module.exports = __webpack_public_path__ + "static/img/yx9.5df8f71.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yx9.jpg
// module id = R1kO
// module chunks = 1